import { PayoutMethod as PayoutMethodModule } from "../modules/PayoutMethod/PayoutMethod";

const PayoutMethod = () => {
  return <PayoutMethodModule />;
};

export default PayoutMethod;
